import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import logo from './assets/images/UGB.svg'
import { ReactComponent as IconSend } from './assets/images/send-icn.svg';
// import logo from './logo.svg';
import './assets/scss/index.scss';
import Content from './components/Content';
import api from './axios/api';
import ModalShowImage from './components/ModalShowImage';
import ButtonFile from './components/ButtonFile';
import { CURRENT_BOT, NEW_BOT } from './constant';

let domainFullNameBot = CURRENT_BOT
if(localStorage.getItem('bot') && localStorage.getItem('bot') === 'new') {
  domainFullNameBot = NEW_BOT
}

window.parent.postMessage(JSON.stringify({type: 'setLinkBot', url: domainFullNameBot}), '*')

const link = new URL(window.location.href).searchParams;
const rootURL = link.get('rootURL');
const rootIdWidget = link.get('idWidget') || link.get('widgetID');
const pathnameHard = rootURL;

class Widget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      newBot: domainFullNameBot === NEW_BOT,
      value: '',
      arrMessage: [],
      countMessage: 1,
      lastParentId: 0,
      showWidget: this.checkDevise(),
      fixedScroll: false,
      time: '',
      pathname: '',
      originURL: '',
      platform: '',
      cliclCloseWidget: false,
      clickCollabseWidget: false,
      deviceConfig: {
        // mobDevice: !window.SharedWorker
        mobDevice: this.checkDevise()
      },
      marker: {
        notReadMessage: false,
        offsetTop: 0
      },
      visibleInputField: true,
      imageURL: '',
      buttonLoadingHistory: {
        show: false,
        isLoading: false,
        clickedButton: false
      },
      notification: {
        show: false,
        type: '',
        text: ''
      }
    }
    this.myRef = React.createRef();
    this.refScroll = React.createRef();
    this.refInput = React.createRef();
    this.fixedScroll = false
    this.scrollPosition = 0
    this.loadingHistory = true
    this.finishLoadingHistory = false
    this.changeQuestion = false
    this.loadingHistoryMob = false
    this.loadingLastHistory = false
    this.initWorkerSuccess = false
    this.currentPathname = ''
    this.paramsWidget = {}
    this.useNodeRed = false
    this.mobDevice = this.checkDevise()
    this.statusWidget = 'hide'
    this.babyToken = ''
    this.dialogId = ''
    this.paramsApp = {}
    this.timer = undefined
    this.pageHistory = 1
  }
  checkDevise = () => {
    // return window.SharedWorker === undefined
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)
  }
  async componentDidMount() {
    const z = this
    const params = new URLSearchParams(link);
    let paramObj = {};
    for(var value of params.keys()) {
        paramObj[value] = params.get(value);
    }
    delete paramObj.rootURL

    this.paramsApp = { ...paramObj }

    if (!localStorage.user)
      localStorage.setItem('user', uuidv4())
      const mob = this.checkDevise();
      if (mob) {
        this.initSSE()
        // alert(window.location.href)
        if(window.location.href.includes('&first=true')){
          const newHref = window.location.href.replace('&first=true', '')
          setTimeout(() => {
            window.location.href = newHref
          }, 1000)
          return 
        }
        await this.getParamsWidget(rootIdWidget)
         // const currentTime = Date.now() // 
        const currentTime = Date.now()
        this.fetchHistory(pathnameHard)
        // eslint-disable-next-line max-len
        // const message = { id: new Date().getTime(), blockType: 9, text: domainFullNameBot + '?name=askme&env=dev ' }
        this.setState({ showWidget: true })
        // if(this.paramsWidget.use_nod_red){
        //   this.setState({ arrMessage: [message] })
        // }
          /* if (
            (localStorage.widgetTimeLastMessage && +localStorage.widgetTimeLastMessage + 1 * 60 * 60 * 1000 < currentTime) || !localStorage.widgetTimeLastMessage
          ) { */
          // window.parent.postMessage(JSON.stringify({ type: 'getCurrentURLPath' }), '*')
        this.setTimeLastMessage(currentTime)
        this.setState({
          pathname: pathnameHard
        })
        // }

        const payload = {
          widgetID: rootIdWidget ,
          pageUri: pathnameHard,
          userToken: localStorage.user,
        }
        const babyTocken = link.get('babyToken')
        const pageUri = link.get('pageUri')
        if(babyTocken){
          payload.babyToken = babyTocken
        }
        if(pageUri){
          payload.pageUri = pageUri
        }
        api.sendMessageOpenWidgetToNodered(payload)
        const z = this
        setTimeout(() => {
          z.refInput.current.setAttribute('autofocus', true)
          z.refInput.current.click()
          z.refInput.current.focus()
          z.refInput.current.blur()
        }, 100)
      }

      window.parent.postMessage(JSON.stringify({ type: 'initWidgetSuccess', userId: localStorage.user}), '*')

    window.addEventListener("message", async event => {
      if(localStorage.getItem('debug')){
        console.log('messageFframe', event);
      }
      if (event.data.frameId) {
        if(event.data.frameId.length && event.data.frameHeight){
          this.updateHeightFrame(event.data.frameId, event.data.frameHeight)
        }
      } else if(event.data.actionType){
        switch (event.data.actionType) {
          case 'closeWidget': {
            const params = new URLSearchParams(link);
            if(params.get('appVersion')){
              setTimeout(() =>  window.location.assign('#close'), event.data.time * 1000)
            } else if(this.mobDevice){  
              setTimeout(() =>  window.close(), event.data.time * 1000)
            } else if(!window.SharedWorker || this.checkDevise()){
              const z = this
              this.timer = setTimeout(() => {
                window.parent.postMessage(JSON.stringify({ type: 'hideWidget', idWidget: z.paramsWidget.idWidget, arrMessage: [] }), '*')
                z.setState({
                  cliclCloseWidget: false,
                  arrMessage: []
                })
              }, event.data.time * 1000)
            } else {
              this.babyToken = ''
              this.worker.port.postMessage({
                method: 'hideWidgetNodeRedBot',
                idWidget: this.paramsWidget.idWidget,
                timeClose: event.data.time
              })
            }
            break;
          }
          case 'showPopup': {
            const z = this
            setTimeout(() => {
              const needScrollToBottom = z.getScrollPositionBottom() < 30
              if(z.statusWidget === 'open'){
                if(event.data.showInWidget){
                  if(window.SharedWorker && !this.checkDevise()){
                    z.worker.port.postMessage({
                      method: 'showBot',
                      urlBot: event.data.url,
                      idWidget: z.paramsWidget.idWidget,
                      scrolling: needScrollToBottom
                    })
                    if(event.data.url.includes('name=estimation')){
                      z.worker.port.postMessage({ method: 'WIDGET_UPDATE_INPUT_FIELD', status: false, idWidget: z.paramsWidget.idWidget})
                      z.worker.port.postMessage({ method: 'WIDGET_UPDATE_COLLAPSE', status: true, idWidget: z.paramsWidget.idWidget})
                    }
                  } else {
                    const message = {
                      id: new Date().getTime(),
                      blockType: 9,
                      text: event.data.url
                    }
                    z.setState({
                      arrMessage: [
                        ...z.state.arrMessage,
                        message
                      ],
                      cliclCloseWidget: event.data.url.includes('name=estimation'),
                      visibleInputField: !event.data.url.includes('name=estimation')
                    }, () => {
                      // if(needScrollToBottom){
                      //   this.updateScrollPosition()
                      // }
                    })
                    z.setTimeLastMessage(Date.now())
                  }
                }
              } else {
                window.parent.postMessage(JSON.stringify({
                  type: 'openPopup',
                  url: event.data.url,
                  showInWidget: typeof event.data.showInWidget === 'boolean' ? event.data.showInWidget : true}), '*')
              }
            }, event.data.time * 1000 || 0)
            break;
          }
          case 'openWidget': {
            const z = this
            setTimeout(() => {
              if(window.SharedWorker && !this.checkDevise()){
                z.worker.port.postMessage({
                  method: 'widget_openWidget',
                  url:  event.data.url,
                  idWidget: z.paramsWidget.idWidget
                })
              }
            }, event.data.time * 1000 || 0)
            break;
          }
          case 'closePopup': {
            setTimeout(() => {
              window.parent.postMessage(JSON.stringify({ type: 'closePopup', }), '*')
            }, event.data.time * 1000 || 0)
            break;
          }
          case 'cancelClosing': {
            if(window.SharedWorker && !this.checkDevise()){
              this.worker.port.postMessage({ method: 'WIDGET_UPDATE_INPUT_FIELD', status: true, idWidget: this.paramsWidget.idWidget})
              this.worker.port.postMessage({ method: 'WIDGET_UPDATE_COLLAPSE', status: false, idWidget: this.paramsWidget.idWidget})
            } else {
              this.setState({
                cliclCloseWidget: false,
                visibleInputField: true
              })
            }
            break;
          }
          default: break;
        }
      } else {
        try {
          const parseData = JSON.parse(event.data)
          if(localStorage.getItem('debug')){
            console.log('parseData', parseData)
          }
          const pathname = parseData.data.hrefUrl || (parseData.data.originURL + parseData.data.pathname) || pathnameHard
          this.setState({
            pathname,
            originURL: parseData.data.originURL,
          })
          if(localStorage.getItem('debug')){
            console.log('event.data', event.data);
          }
          if(parseData.type === 'closeWidget'){
            this.hideWidget(null, true)
            this.hidePopup()
          } else if(parseData.type === 'showMainPage'){
            if(this.paramsWidget.use_nod_red){
              if(window.SharedWorker && !this.checkDevise()){
                // this.worker.port.postMessage({ method: 'showMainPage', idWidget: this.paramsWidget.idWidget })
              } else {
                const message = {
                  id: new Date().getTime(),
                  blockType: 9,
                  text: domainFullNameBot + '?name=askme'
                }
                this.setState({
                  arrMessage: [...this.state.arrMessage, message],
                })
              }
            }
          }
          if (parseData.type === 'currentURLPath') {
            if (window.SharedWorker && !this.checkDevise()) {
              if (parseData.data.otherParams) {
                const { method, type, data } = parseData.data.otherParams
                if (method === "handleNavigation") {
                  this.worker.port.postMessage({ method: method, type, pathname, idWidget: this.paramsWidget.idWidget })
                } else if (method === 'submitSearch') {
                  this.worker.port.postMessage({ method: method, data, pathname, idWidget: this.paramsWidget.idWidget })
                }
              } else {
                this.worker.port.postMessage({ method: 'frequentlyAskedQuestion', pathname, idWidget: this.paramsWidget.idWidget })
              }     
            } else {
              const currentPathname = this.currentPathname
              const data = this.state.arrMessage
              if (parseData.data.otherParams) {
                const { method, data } = parseData.data.otherParams
                if (method === "handleNavigation") {
                  this.frequentlyAskedQuestion(pathnameHard)
                } else if (method === 'submitSearch') {
                  this.frequentlyAskedQuestion(pathnameHard, data)
                }
              } else {
                if (!data.length || (data[data.length - 1].blockType === 1 && currentPathname !== (pathnameHard))) {
                  this.currentPathname = pathnameHard
                  this.frequentlyAskedQuestion(pathnameHard)
                }
              }
            }
            return
          } else if (parseData.type === 'init' && !this.initWorkerSuccess) {
            this.paramsWidget = {
              ...this.paramsWidget,
              idWidget: parseData.data.idWidget
            }
            await this.getParamsWidget(parseData.data.idWidget)
            this.initWorkerSuccess = true
            this.setState({ showWidget: true })
            const pathname = parseData.data.hrefUrl || (parseData.data.originURL + parseData.data.pathname)
            const {idWidget} = parseData.data
            if (window.SharedWorker && !this.checkDevise()) {
              this.initWorker(pathname, idWidget, this.paramsWidget)
            } else {
              this.initSSE()
              const currentTime = Date.now()
              this.fetchHistory(pathname)
              const message = {
                id: new Date().getTime(),
                blockType: 9,
                text: domainFullNameBot + '?name=askme'
              }
              this.setState({
                pathname,
                idWidget,
                arrMessage: [message],
                originURL: parseData.data.originURL,
                showWidget: true,
                platform: 'ios'
              })
              this.setTimeLastMessage(currentTime)
            }
          } else if (parseData.type === 'popupCreated') {
            const message = {
              method: 'showBot',
              id: parseData.data.id,
              blockType: 9,
              text: parseData.data.url,
              idWidget: this.paramsWidget.idWidget,
              replace: true
            }
            this.setState({
              cliclCloseWidget: parseData.data.url.includes('name=estimation')
            })
            if(window.SharedWorker && !this.checkDevise()){
              this.worker.port.postMessage(message)
            } else {
              this.setState({
                arrMessage: [
                  ...this.state.arrMessage,
                  message
                ],
              })
            }
          } else if(parseData.type === 'statusWidget'){
            const {use_nod_red, idWidget} = this.paramsWidget
            this.statusWidget = parseData.data.status
            if(parseData.data.status === 'open' && use_nod_red && !this.state.clickCollabseWidget){
              clearTimeout(this.timer)
              const payload = {
                widgetID: idWidget ,
                pageUri: parseData.data.hrefUrl,
                userToken: localStorage.user,
              }
              if(parseData.data.babyToke){
                payload.babyToken = parseData.data.babyToke
              }
              api.sendMessageOpenWidgetToNodered(payload)
            }
            if(parseData.data.status === 'open' && use_nod_red && this.state.clickCollabseWidget){
              this.sendStatusWidget('open')
            }
            if(parseData.data.status === 'hide' && use_nod_red && parseData.data.buttonClick){
              this.setState({ clickCollabseWidget: true })
              this.sendStatusWidget('close')
            }
            if(window.SharedWorker && !this.checkDevise()){
              this.worker.port.postMessage({
                method: 'WIDGET_SET_STATUS_VISIBLE',
                status: parseData.data.status,
                idWidget: this.paramsWidget.idWidget,
                buttonClick: parseData.data.buttonClick
              })
            } else {
              if(parseData.data.status === 'hide' && use_nod_red && !parseData.data.buttonClick){
                this.setState({
                  arrMessage: []
                })
              }
            }
          } else if(parseData.type === 'site_showBot'){
            this.worker.port.postMessage({
              method: 'showBot',
              urlBot: parseData.data.url,
              idWidget: this.paramsWidget.idWidget
            })
          } else if(parseData.type === 'site_updateHeightWidget'){
            this.updateHeightFrame(parseData.data.frameId, parseData.data.frameHeight)
          } else if(parseData.type === 'INIT_set_tk'){
            console.log('parseData_update_token_in_worker', parseData);
            if(parseData.token){
              if(window.SharedWorker && !this.checkDevise()){
                this.worker.port.postMessage({
                  method: 'update_token_in_worker',
                  urlBot: parseData.data.url,
                  idWidget: this.paramsWidget.idWidget,
                  token: parseData.token
                })
              } else {
                this.babyToken = parseData.token
                // localStorage.setItem('user', parseData.token)
              }
            } 
          } else if(parseData.type === 'INIT_auts_user'){
            if (parseData.token) {
              try {
    /*             if(localStorage.isSendToken === 'false' || !localStorage.isSendToken) {
                  localStorage.isSendToken = 'true' */
                  const data = {
                    dialog_id: this.dialogId,
                    babyToken: parseData.token
                  }
                  api.sendTokenAfterAuth(data)
                    // .finally(() => localStorage.isSendToken = 'false')
                // }
              } catch (error) {
                // localStorage.isSendToken = 'false'
              }
            }
          }
        } catch (error) {
          console.log('ERROR');
          console.log(error);
        }
      }
    });
  }

  sendStatusWidget = (status) => {
    const payload = {
      dialog_id: this.dialogId,
      state: status
    }
    api.sendNoderedStatusWidget(payload)
  }

  initWorker = (pathname, idWidget, paramsWidget) => {
    const worker = new SharedWorker(`./workerWidget.js?${idWidget}&v=1.0`, { name: 'widget' });
    worker.port.start();
    worker.port.postMessage({ method: "init", tkn: localStorage.user, pathname, idWidget, paramsWidget, domainFullNameBot })
    const broadcastChannel = new BroadcastChannel("WebSocketChannel");
    broadcastChannel.addEventListener("message", (event) => {
      const { type, data, idWidget } = event.data
      console.log('message worker', type, idWidget, data);
      if(idWidget === this.paramsWidget.idWidget) {
        switch (type) {
          case 'messenger':
          case 'askedQuestion': {
            const parseData = JSON.parse(data)
            if (parseData.scrollToEnd)
              this.fixedScroll = false
            if (type === 'messenger')
              this.fixedScroll = true
            this.setState({
              fixedScroll: false,
              arrMessage: [
                ...this.state.arrMessage,
                ...parseData.arrMessage
              ],
              lastParentId: parseData.lastParentId || this.state.lastParentId
            }, () => {
              type === 'askedQuestion' && this.updateScrollPosition()
              if(parseData.arrMessage && parseData.arrMessage.length && parseData.arrMessage[parseData.arrMessage.length - 1]) {
                const lastMessage = parseData.arrMessage[parseData.arrMessage.length - 1]
                if(lastMessage.blockType === 9){
                  this.setState({
                    visibleInputField: lastMessage.text.includes('name=estimation'),
                    cliclCloseWidget: lastMessage.text.includes('name=estimation')
                  })
                }
              }
            })
            break;
          }
          case 'handleChangeFAQ': {
            const parseData = JSON.parse(data)
            this.fixedScroll = false
            this.setState({
              fixedScroll: false,
              arrMessage: [
                ...this.state.arrMessage,
                ...parseData
              ],
            }, () => this.updateScrollPosition())
            // this.fixedScroll = false
            break
          }
          case 'clientMessage': {
            const clientMessage = JSON.parse(data)
            this.setState({
              value: '',
              fixedScroll: false,
              cliclCloseWidget: false,
              arrMessage: [
                ...this.state.arrMessage,
                clientMessage
              ],
            })
            break
          }
          case 'handleResultAsked': {
            this.updateRaitingResult(JSON.parse(data))
            break
          }
          case 'hideWidget': return this.hideWidget()
          case 'collapseWidget': {
            window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*') 
            this.setState({ clickCollabseWidget: true })
            break;
          }
          case 'showRaiting':
          case 'handleNavigation': {
            if (type === 'handleNavigation')
              this.fixedScroll = false
            this.setState({
              fixedScroll: false,
              arrMessage: [
                ...this.state.arrMessage,
                ...JSON.parse(data)
              ]
            }, () => type === 'handleNavigation' && this.updateScrollPosition())
            break;
          }
          case 'addHistory': {
            this.loadingHistory = (this.loadingHistory === null)
            const newArrHistoryWithoutDuplicate = []
            const parsedArrMessages = JSON.parse(data)
            parsedArrMessages.forEach(message => {
              if(!this.state.arrMessage.some(messageInStore =>  messageInStore.id === message.id)){
                newArrHistoryWithoutDuplicate.push(message)
              }
            })
            
            this.setState({
              // fixedScroll: true,
              arrMessage: [
                ...newArrHistoryWithoutDuplicate,
                ...this.state.arrMessage,
              ],
              buttonLoadingHistory: {
                ...this.state.buttonLoadingHistory,
                isLoading: false
              }
            }, () => this.updateScrollPosition(true))
            break;
          }
          case 'showBotRaiting': {
            const {arrMessage} = this.state
            const message = data.botRaiting
            let newArrMessages = [...arrMessage]
            if(message){
              if(message.replace) {
                newArrMessages.push(message)
              } else {
                newArrMessages = [ ...arrMessage.slice(0, arrMessage.length - 1), message ]
              }
            }
            // if (message.replace) {
            //   console.log('arrMessage', arrMessage)
            //   this.setState({
            //     cliclCloseWidget: true,
            //     arrMessage: [
            //       ...arrMessage,
            //       //...arrMessage.slice(0, arrMessage.length - 1),
            //       message
            //     ],
            //   }, () => this.updateScrollPosition())
            //   break;
            // } else {
            //   console.log('arrMessage', arrMessage)
            //   this.setState({
            //     cliclCloseWidget: true,
            //     arrMessage: [
            //       ...arrMessage.slice(0, arrMessage.length - 1),
            //       message
            //     ],
            //   }, () => this.updateScrollPosition())
            //   break;
            // }
            this.setState({
              cliclCloseWidget: true,
              arrMessage: [ ...newArrMessages ],
            }, () => this.updateScrollPosition())
            break;
          }
          case 'hideWidgetNodeRedBot': {
            const mob = this.checkDevise();
            const z = this
            if(event.data.timeClose){
              this.timer = setTimeout(
                () => {
                  if(mob){
                    window.close()
                    z.setState({ cliclCloseWidget: false, clickCollabseWidget: false, buttonLoadingHistory: {
                      show: false,
                      isLoading: false,
                      clickedButton: false
                    }})
                  } else {
                    this.babyToken = ''
                    window.parent.postMessage(JSON.stringify({ type: 'hideWidget', idWidget: this.paramsWidget.idWidget }), '*')
                    const newArr = event.data.sliceLastMessage ? this.state.arrMessage.slice(0, this.state.arrMessage.length - 1) : this.state.arrMessage
                    z.setState({
                      cliclCloseWidget: false,
                      clickCollabseWidget: false,
                      arrMessage: [ ...newArr ],
                      buttonLoadingHistory: {
                        show: false,
                        isLoading: false,
                        clickedButton: false
                      }
                    })
                  }
                },
                event.data.timeClose * 1000
              )
            } else {
              // const message = {
              //   id: this.state.arrMessage.length + 1,
              //   blockType: 9,
              //   text: 'https://ecochatbots.s3.eu-central-1.amazonaws.com/testbots/index.html?name=askme&env=dev'
              // }
              const newArr = event.data.sliceLastMessage ? this.state.arrMessage.slice(0, this.state.arrMessage.length - 1) : this.state.arrMessage
              z.setState({
                cliclCloseWidget: false,
                clickCollabseWidget: false,
                arrMessage: [ ...newArr ]
              })
              if(mob){
                window.close()
              } else {
                window.parent.postMessage(JSON.stringify({ type: 'hideWidget', idWidget: this.paramsWidget.idWidget }), '*')
              }
            }
           
            break;
          }
          case 'collapseWidgetNodeRedBot': {
            const mob = this.checkDevise();
            const z = this
            if(event.data.timeClose){
              setTimeout(
                () => {
                  if(mob){
                    window.close()
                    z.setState({ clickCollabseWidget: true})
                  } else {
                    window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*')
                    //const newArr = this.state.arrMessage.slice(0, this.state.arrMessage.length - 1)
                    z.setState({
                      clickCollabseWidget: true,
                      //arrMessage: [ ...newArr ]
                    })
                  }
                },
                event.data.timeClose * 1000
              )
            } else {
              // const message = {
              //   id: this.state.arrMessage.length + 1,
              //   blockType: 9,
              //   text: 'https://ecochatbots.s3.eu-central-1.amazonaws.com/testbots/index.html?name=askme&env=dev'
              // }
              //const newArr = this.state.arrMessage.slice(0, this.state.arrMessage.length - 1)
              const newArr = this.state.arrMessage
              z.setState({
                clickCollabseWidget: true,
                arrMessage: [ ...newArr ]
              })
              if(mob){
                window.close()
              } else {
                window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget, tkn: localStorage.user}), '*')
              }
            }
           
            break;
          }
          case 'worker_swowBot': {
            const {arrMessage} = this.state
            const message = JSON.parse(data)
            this.setState({
              arrMessage: [
                ...arrMessage,
                message
              ],
            }, () => {
              if(event.data.scrolling){
                this.updateScrollPosition(null, null, )
              } else {
                this.setState({
                 marker: {
                   ...this.state.marker,
                   notReadMessage: true,
                   offsetTop: this.state.marker.offsetTop === 0 ? this.getScrollPositionBottom() - this.myRef.current.lastChild.offsetHeight + 30 : this.state.marker.offsetTop,
                   element: this.state.marker.element ? this.state.marker.element : this.myRef.current.lastChild
                 }

                })
              }
            })
            break;
          }
          case 'worker_openWidget': {
            window.parent.postMessage(JSON.stringify({ type: 'openWidget', url: event.data.url}), '*')
            break;
          }
          case 'worker_update_token': {
            // const token = JSON.parse(data)
            this.babyToken = data
            break;
          }
          case 'worker_set_status_visible': {
            this.statusWidget = data
            window.parent.postMessage(JSON.stringify({ type: 'widget_set_visible', status: data}), '*')
            break
          }
          case 'worker_set_messages_list': {
            this.setState({
              ...this.state,
              arrMessage: data || []
            })
            break
          }
          case 'worker_set_status_input_field': {
            this.setState({ visibleInputField: event.data.status })
            break
          }
          case 'worker_update_collapse': {
            this.setState({ cliclCloseWidget: event.data.status })
            break
          }
          case 'worker_update_dialogId': {
            this.dialogId = event.data.dialogID
            break
          } 
          case 'worker_add_messsage': {
            this.setState({
              arrMessage: [
                ...this.state.arrMessage,
                ...event.data.arrMessages
              ]
            }, () => {
              this.updateScrollPosition()
            })
            break
          }
          case 'worker_replace_messsage': {
            let isScrolling = false

            const z = this
            const newArr = this.state.arrMessage.map(message => {
              const messageForUpdate = event.data.arrMessages.find(updatedMessage => updatedMessage.id === message.id)
        
              if(!messageForUpdate){ return message}
        
              isScrolling = message.fileType && message.fileType.includes('image')
              return { ...message, ...messageForUpdate }
            })

            this.setState(
              { arrMessage: newArr }
              , () => {
                if(isScrolling){
                  setTimeout(() => {
                    z.updateScrollPosition()
                  }, 500)
                }
                
              })
            break
          }

          case 'worker_show_button_get_history': {
            const parseConfigButtonLoadingHistory = JSON.parse(data)
            console.log('[history: parse status]', parseConfigButtonLoadingHistory)
            this.setState(prevState => ({
              ...prevState,
              buttonLoadingHistory: {...parseConfigButtonLoadingHistory}
            }))
            break
          }

          case 'worker_show_notification': {
            const parseConfigNotification = JSON.parse(data)
            this.setState(prevState => ({
              ...prevState,
              notification: {...parseConfigNotification}
            }))
            break
          }

          case 'worker_update_url_bot': {
            console.log('worker_update_url_bot', data)
            this.updateUrlBot(data.url)
            break
          }
          
          default:
            break;
        }
      }
    })

    worker.port.onmessage = event => {
      const { type, data } = event.data
      console.log('messageWorker port', type, JSON.parse(data));
      switch (type) {
        case 'setConfig': {
          const parseData = JSON.parse(data)
          this.babyToken = parseData.babyToke
          this.dialogId = parseData.dialogId
          this.setState({
            cliclCloseWidget: parseData.cliclCloseWidget,
            clickCollabseWidget: parseData.collapseWidget
          })
          if(parseData.collapseWidget){
            window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*') 
          }
          break;
        }
        case 'askedQuestion': {
          const parseData = JSON.parse(data)
          this.setState({
            arrMessage: [
              ...this.state.arrMessage,
              ...parseData.arrMessage
            ],
            lastParentId: parseData.lastParentId
          }, async () => await this.updateScrollPosition(false, true))
            ; break;
        }
        case 'worker_set_status_visible': {
          const parseData = JSON.parse(data)
          this.statusWidget = parseData.status
          window.parent.postMessage(JSON.stringify({ type: 'widget_set_visible', status: parseData.status}), '*')

          break
        }

        default: break
      }
    }
    this.worker = worker
    const currentTime = Date.now()
    if (
      (localStorage.widgetTimeLastMessage && +localStorage.widgetTimeLastMessage + 1 * 60 * 60 * 1000 < currentTime)
    ) {
      // window.parent.postMessage(JSON.stringify({ type: 'getCurrentURLPath' }), '*')
      this.setTimeLastMessage(currentTime)
    }
  }

  initSSE = () => {
    const z = this 
    this.eventSource = new EventSource(`https://eco-widget.ukrgasaws.com/api-async/widget/users/${localStorage.user}/messages`);

    this.eventSource.onmessage = function(event) {
      if(localStorage.getItem('debug')){
        console.log("Новое сообщение", event.data)
      }

      const {kind, attributes} = JSON.parse(event.data)
      if(kind === "message") {
        const {message, messageType, dialogID, files, phone} = attributes
        const id = Date.now()
        let newData,
            save = false
        switch (messageType) {
          case 'bot': {
            save = true
            newData = [{ id, blockType: 9, text: message, heightFrame: 310 }]

            if(message.includes('name=estimation')) {
              save = false
              z.setState({
                arrMessage: [
                  ...newData,
                ],
                cliclCloseWidget: true,
                lastParentId: id
              }, () => {
                z.updateScrollPosition()
              })
            }
            break;
          }

            case 'info': {
              if(dialogID){
                z.getHistoryForNodeRedBot(dialogID)
                z.dialogId = dialogID

                if(phone.length) {
                  z.paramsWidget = {
                    ...z.paramsWidget,
                    phone,
                  }
                  z.setState({
                    buttonLoadingHistory: {
                      show: true,
                      isLoading: false,
                      clickedButton: false
                    }
                  })
  
                }

              const message = { id: new Date().getTime(), blockType: 9, text: domainFullNameBot + '?name=askme' }
              z.setState({ arrMessage: [message] })
            }
            break
          }
        
          default: {
            newData = [{ id, blockType: 6, text: message }]
            save = true

            if(files && files.length){
              newData = files.map(fileParams => {
                return {
                  id: new Date().getTime(),
                  blockType: 10,
                  fileName: fileParams.file_name,
                  fileURL: fileParams.file_url,
                  fileSize: fileParams.file_size,
                  fileType: fileParams.file_type,
                  typeMessage: 'system',
                  status: 'success'
                }
              })
            }
            break;
          }
        }
        if(save){
          z.setState({
            arrMessage: [
              ...z.state.arrMessage,
              ...newData,
            ],
            lastParentId: id
          }, () => {
            z.updateScrollPosition()
          })
        }

      }
    };
    this.eventSource.onopen = () => {
      console.log('SSE open sse');
    }
  }

  getHistoryForNodeRedBot = (dialogId) => { // tkn
    api.getHistory(dialogId)
    .then(res => {
      if(res.status === 200){
        const parsedHistoryMessages = res.data.messages
        ? res.data.messages
          .filter(history => history.text && history.text.length)
          .map(history => {
            if (history.files && history.files.length) {
              const file = history.files[0]
              return {
                id: new Date().getTime(),
                blockType: 10,
                fileName: file.file_name,
                fileURL: file.file_url,
                fileSize: file.file_size,
                fileType: file.file_type,
                typeMessage: history.role === "client" ? 'user' : 'system' ,
                status: 'success'
              }
            } else {
              return {
                id: history.id,
                blockType: history.role === "client" ? 5 : 6,
                text: history.text
              }
            }
          })
        : []  

          const newArrHistoryWithoutDuplicate = []
            parsedHistoryMessages.forEach(message => {
              if(!this.state.arrMessage.some(messageInStore =>  messageInStore.id === message.id)){
                newArrHistoryWithoutDuplicate.push(message)
              }
            })
        this.setState({
          arrMessage: [
            ...newArrHistoryWithoutDuplicate,
            ...this.state.arrMessage
          ]
        })

      }
    })
  }

  getParamsWidget = async (idWidget) => {
    await api.getParamsWidget(idWidget).then(res => {
      this.paramsWidget = {
        ...this.paramsWidget,
        ...res.data
      }
    })
  }

  componentDidUpdate() {
    if (this.myRef && this.state.showWidget) {
      // console.log('current: ', this.myRef.current.lastChild && this.myRef.current.lastChild.getBoundingClientRect());
      // console.log('lastChild: ', this.myRef.current && this.myRef.current.childNodes, this.myRef.current.height);
      // // if(this.myRef.current)
      // console.log(this.state.fixedScroll);
      // // if (!this.state.fixedScroll) {
      // //   this.myRef.current.scrollTop = this.myRef.current.scrollHeight
      // //   console.log(this.myRef.current.scrollTop, this.myRef.current.scrollHeight);
      // //   // this.myRef.current.lastChild && this.myRef.current.lastChild.scrollIntoView({ block: "end", behavior: "smooth" })
      // // }
      // console.log(this.refScroll.current.scrollTop, this.refScroll.current.clientHeight, this.refScroll.current.childNodes);
      // console.log(this.myRef.current.lastChild);

    }
    const allLinks = document.getElementsByTagName('a')
    for (let i = 0; i < allLinks.length; i++) {
      if (allLinks[i].className !== 'messenger')
        allLinks[i].target = "_blank"
    }
  }

  updateScrollPosition = (updateFixedPosition, quick) => {
    if (updateFixedPosition) {
      const t = this.currentHeighScrollContainer - this.currentTopScrollContainer
      // eslint-disable-next-line max-len
      this.refScroll.current.scrollTop = this.scrollPosition === 0 ? this.refScroll.current.scrollHeight : this.refScroll.current.scrollHeight - t
    } else {
      if(quick){
        this.myRef.current.parentElement.scrollTop = this.myRef.current.parentElement.scrollHeight
      } else if(this.myRef.current.lastChild)
        this.smoothScroll(this.myRef.current.lastChild)
    }
    return true
  }

  handleChangeScrollMarker = () => {
    const {element} = this.state.marker
    this.smoothScroll(element)
    this.setState({
      marker: {
        ...this.state.marker,
        notReadMessage: false,
        offsetTop: 0,
        element: undefined
      }
    })
  }

  smoothScroll = (eID) => {
    var startY = this.refScroll.current.scrollTop;
    var stopY = eID.offsetTop;
    var distance = stopY > startY ? stopY - startY : startY - stopY;
    if (distance < 100) {
      if (this.refScroll.current.scrollTo) {
        this.refScroll.current.scrollTo(0, stopY); return;
      } else {
        this.refScroll.current.scrollTop = 0
      }
    }
    var speed = Math.round(distance / 100);
    if (speed >= 20) speed = 20;
    var step = Math.round(distance / 25);
    var leapY = stopY > startY ? startY + step : startY - step;
    var timer = 0;
    if (stopY > startY) {
      for (var i = startY; i < stopY; i += step) {
        // eslint-disable-next-line
        setTimeout(() => {
          const t = leapY
          if (this.refScroll.current.scrollTo) {
            this.refScroll.current.scrollTo({
              top: t - 65,
              behavior: "smooth"
            })
          } else {
            this.refScroll.current.scrollTop = t - 65
          }
        }, timer * speed);
        leapY += step; if (leapY > stopY) leapY = stopY; timer++;
      } return;
    }
  }

  setTimeLastMessage = (time) => {
    const currentTime = Date.now()
    localStorage.setItem('widgetTimeLastMessage', time || currentTime)
  }

  frequentlyAskedQuestion = (pathname, queryParams) => {
    const {use_nod_red} = this.paramsWidget
    let urlPathname = pathname || ''
    if (pathname && pathname.length && pathname[pathname.length - 1] === '/')
      urlPathname = pathname.slice(0, pathname.length - 1)
    const {idWidget} = this.paramsWidget
    // eslint-disable-next-line max-len
    let url = `${'?categoryPath=' + (urlPathname || '')}&useNodRed=${this.paramsWidget.use_nod_red}&widgetID=${idWidget || rootIdWidget}${queryParams ? '&query=' + queryParams : ''}`
    if(this.babyToken.length){
      url = url + '&babyToken=' + this.babyToken
    }
    api.fetchFrequentlyAskedQuestion(url).then(res => {
      if (res.status === 200) {
        if(use_nod_red){
          let id = Date.now(), newData = []
        // eslint-disable-next-line max-len
        if (res.data.type === 'text' && res.datapParams.message.length) {
          newData = [{ id, blockType: 8, text: res.datapParams.message }]
        } else if (res.data.type === 'bot') {
          newData = [{ id, blockType: 9, text: res.data.bot.url }]
        }
        // if (res.data.length)
        //   newData = [{ id, blockType: queryParams ? 2 : 1, variable: res.data, title: queryParams ? '' : 'Популярні питання' }]
        // else
        //   newData = [{ id, blockType: 6, text: 'Будь ласка, уточніть ваше питання' }]
        this.setState({
          arrMessage: [
            ...this.state.arrMessage,
            ...newData,
          ],
          lastParentId: res.data.length ? id : this.state.lastParentId
        }, () => {
          this.updateScrollPosition()
          // if (queryParams)
          //   this.setState({
          //     arrMessage: [...this.state.arrMessage, { id: id + 1, blockType: 7 }]
          //   })
        })
        } else {
          let id = Date.now(), newData
        if (res.data.length)
          newData = [{ id, blockType: queryParams ? 2 : 1, variable: res.data, title: queryParams ? '' : 'Популярні питання' }]
        else
          newData = [{ id, blockType: 6, text: 'Будь ласка, уточніть ваше питання' }]
        this.setState({
          arrMessage: [
            ...this.state.arrMessage,
            ...newData,
          ],
          lastParentId: res.data.length ? id : this.state.lastParentId
        }, () => {
          this.updateScrollPosition()
          if (queryParams)
            this.setState({
              arrMessage: [...this.state.arrMessage, { id: id + 1, blockType: 7 }]
            })
        })
        }
        
      }
    })
  }
  handleChange = e => {
    const { value } = e.target
    this.changeQuestion = true
    this.setState({ value })
    // this.setState({ value }, () => this.worker.postMessage(value))
  }
  handleChangeFAQ = idGroup => e => {
    this.setTimeLastMessage()
    const { arrMessage } = this.state
    const selectedGroup = arrMessage.find(group => group.id === idGroup)
    const selectedFAQ = selectedGroup.variable.find(faq => faq.id === e.target.id)
    const answer = [{
      id: selectedFAQ.id,
      blockType: 3,
      title: selectedFAQ.name,
      text: selectedFAQ.text,
      parentId: selectedFAQ.id
    }]
    if (this.state.deviceConfig.mobDevice) {
      this.fixedScroll = false
      this.setState({
        arrMessage: [
          ...arrMessage,
          ...answer
        ]
      }, () => {
        this.updateScrollPosition()
        this.sendView(selectedFAQ.id)
        // this.showMessangers()
      })
    } else {
      this.worker.port.postMessage({ method: "handleChangeFAQ", data: JSON.stringify(answer), idWidget: this.paramsWidget.idWidget })
    }
  }
  sendView = faqID => api.sendView({ faqID })
  showMessangers = () => {
    const { arrMessage } = this.state
    this.fixedScroll = true
    this.setState({
      arrMessage: [
        ...arrMessage,
        { id: Date.now(), blockType: 7 }
      ]
    })
  }
  showRaiting = faqID =>
    api.checkShowRaiting(faqID)
      .catch(error => {
        if (error.response.status === 404)
          this.setState({
            arrMessage: [...this.state.arrMessage, { id: faqID, blockType: 4, result: '', idFaq: faqID }]
          })
      })

  showNavigationButton = (item) => {
    const { arrMessage } = this.state
    const lastItem = item || arrMessage[arrMessage.length - 1]
    if (!lastItem) return

    if (lastItem.blockType === 2 || lastItem.blockType === 3 || lastItem.blockType === 4)
      return {
        goBack: true,
        goHome: true
      }
    else if (lastItem.blockType === 7) {
      const preLast = arrMessage[arrMessage.length - 2]
      if (preLast.blockType === 3) {
        return {
          goBack: true,
          goHome: true
        }
      } else {
        return {
          goBack: false,
          goHome: true
        }
      }
    }
    else if (lastItem.blockType === 1 && !lastItem.title.length) {
      return {
        goBack: false,
        goHome: true
      }
    } else if (lastItem.blockType === 8) {
      return {
        goBack: true,
        goHome: true
      }
    }
  }
  handleNavigation = type => {
    const { arrMessage, lastParentId } = this.state
    if (this.state.deviceConfig.mobDevice) {
      this.fixedScroll = false
      if (type === 'home')
        this.setState({
          countMessage: this.state.countMessage + 1,
        }, () => {
          this.frequentlyAskedQuestion(pathnameHard)
        })
      if (type === 'back') {
        const lastItem = arrMessage.find(item => item.id === lastParentId)
        if (lastItem.title && lastItem.title.length) {
          this.frequentlyAskedQuestion(pathnameHard)
        } else {
          const {use_nod_red} = this.paramsWidget
          if(use_nod_red){
            this.setState({
              arrMessage: [...arrMessage, { ...lastItem }] // , { id: Date.now(), blockType: 7 }
            }, () => this.updateScrollPosition())
          } else {
            this.setState({
              arrMessage: [...arrMessage, { ...lastItem }, { id: Date.now(), blockType: 7 }]
            }, () => this.updateScrollPosition())
          }
        }
      }
    } else {
      window.parent.postMessage(JSON.stringify({
        type: 'getCurrentURLPath',
        data: {
          method: 'handleNavigation',
          type,
          idWidget: this.paramsWidget.idWidget
        }
      }), '*')
    }
  }
  handleSubmit = e => {
    e.preventDefault()
    this.setTimeLastMessage()
    this.changeQuestion = false
    const { value } = this.state
    if (this.state.value.trim().length) {
      if (this.state.deviceConfig.mobDevice || !window.SharedWorker) {
        const clientMessage = {
          id: Date.now(),
          blockType: 5,
          typeMessage: 'client_message',
          text: value
        }
        this.setState({
          cliclCloseWidget: false,
          arrMessage: [...this.state.arrMessage, clientMessage],
          value: ''
        }, () => {
          const path = this.state.platform === 'ios' ? this.state.pathname : pathnameHard
          const data = clientMessage;
            this.frequentlyAskedQuestion(path, data.text)
          }
        )
      } else {
        window.parent.postMessage(JSON.stringify({
          type: 'getCurrentURLPath',
          data: { method: 'submitSearch', data: value, idWidget: this.paramsWidget.idWidget }
        }), '*')
        // this.worker.port.postMessage({ method: "submitSearch", data: value })
      }
    }
  }
  handleResultAsked = (id, rating) => () => {
    const paramsResult = { id, rating }
    if (this.state.deviceConfig.mobDevice) {
      const dataSubmit = {
        faqID: id,
        rating
      }
      api.postData('api/widget/ratings', dataSubmit).then(res => {
        if (res.status === 200)
          this.updateRaitingResult({ id, rating })
      })
    } else {
      this.worker.port.postMessage({
        method: 'handleResultAsked',
        data: JSON.stringify(paramsResult),
        idWidget: this.paramsWidget.idWidget
      })
    }
  }
  updateRaitingResult = ({ id, rating }) => {
    const { arrMessage } = this.state
    let update
    const newArray = arrMessage.map(message => {
      if (message.idFaq && message.idFaq === id) {
        update = true
        return { ...message, rating }
      }
      return message
    })
    if (update) {
      this.setState({
        fixedScroll: false, arrMessage: [...newArray, { id, blockType: 8, text: 'Дякуємо за оцінку!' }]
      }, () => this.updateScrollPosition())
    }
  }

  handleClickMessanger = () => {
    if (!this.state.deviceConfig.mobDevice)
      this.worker.port.postMessage({ method: 'hideWidget', idWidget: this.paramsWidget.idWidget })
  }
  
  hideWidget = (e ,close) => { 
    const mob = this.checkDevise();
    if(!this.paramsWidget.use_nod_red){
      if(mob){
        window.close();
      } else if(!window.SharedWorker ||this.checkDevise()) {
        window.parent.postMessage(JSON.stringify({ type: 'hideWidget', idWidget: this.paramsWidget.idWidget }), '*')
      } else {
        this.worker.port.postMessage({ method: 'hideWidgetNodeRedBot', idWidget: this.paramsWidget.idWidget})
      }
    } else {
      if(this.state.cliclCloseWidget || close){
        const payload = { 
          dialogID: this.dialogId,
          closedBy: 'client'
        }
        api.sendMessageCloseWidgetToNodered(payload)
        const params = new URLSearchParams(link);
        if(params.get('appVersion')){
          window.location.assign('#close')
          window.location.assign('#')
        } else if(mob){
          window.close();
        } else if(!window.SharedWorker || this.checkDevise()) {
          window.parent.postMessage(JSON.stringify({ type: 'hideWidget', idWidget: this.paramsWidget.idWidget, sliceLastMessage: !close }), '*')
          this.setState({cliclCloseWidget: false, visibleInputField: true, buttonLoadingHistory: {
            show: false,
            isLoading: false,
            clickedButton: false
          }})
        } else {
          this.worker.port.postMessage({ method: 'hideWidgetNodeRedBot', idWidget: this.paramsWidget.idWidget})
        }

      } else {
        const message = {
          id: 2,
          blockType: 9,
          text: domainFullNameBot + '?name=estimation&step=step1&close_by=client'
        }
        if (mob || !window.SharedWorker || this.checkDevise()) {
          console.log('debug')
          this.setState({
            cliclCloseWidget: true,
            visibleInputField: false, 
            arrMessage: [
              // ...this.state.arrMessage.slice(0, this.state.arrMessage.length - 1),
              message
            ],
            buttonLoadingHistory: {
              show: false,
              isLoading: false,
              clickedButton: false
            }
          }, () =>{
            console.log('debug', this.state.buttonLoadingHistory)
            this.updateScrollPosition()
          })
        } else {
          this.setState({ cliclCloseWidget: true,  buttonLoadingHistory: {
            show: false,
            isLoading: false,
            clickedButton: false
          }})
          this.worker.port.postMessage({ method: 'showBotRaiting', botRaiting: message, idWidget: this.paramsWidget.idWidget})
          this.worker.port.postMessage({ method: 'WIDGET_UPDATE_INPUT_FIELD', status: false, idWidget: this.paramsWidget.idWidget})
        }
      }
      
    }
  }

  collapseWidget = (clickButton) => {
    if(!this.paramsWidget.use_nod_red){
      return 
    } else {
      if(clickButton){
        this.sendStatusWidget('close')
      }
      if(!window.SharedWorker || this.checkDevise()) {
        window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*')
      } else {
        this.worker.port.postMessage({ method: 'collapseWidget',  idWidget: this.paramsWidget.idWidget })
        
      }
      this.setState({ clickCollabseWidget: true, })



      if(this.state.clickCollabseWidget){
         if(!window.SharedWorker || this.checkDevise()) {
          window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*')
          this.setState({ arrMessage: []})
        } else {
          //this.worker.port.postMessage({ method: 'collapseWidgetNodeRedBot', idWidget: this.paramsWidget.idWidget})
          window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*')
        }

      } else {
        
        if(!window.SharedWorker || this.checkDevise()) {
          window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*')
        } else {
          this.setState({ clickCollabseWidget: true, })
          //this.worker.port.postMessage({ method: 'showBotRaiting', botRaiting: message, idWidget: this.paramsWidget.idWidget})
          //this.worker.port.postMessage({ method: 'collapseWidget', botRaiting: message, idWidget: this.paramsWidget.idWidget})
          window.parent.postMessage(JSON.stringify({ type: 'collapseWidget', idWidget: this.paramsWidget.idWidget }), '*')
        }
      }
      
    }
  }

  sendViewFaq = id => this.worker.port.postMessage({ method: 'hideWidget', id, idWidget: this.paramsWidget.idWidget })
  getScrollPositionBottom = () => {
    return this.refScroll.current.scrollHeight - (this.refScroll.current.scrollTop +  this.refScroll.current.clientHeight)
  }
  scrollContainer = e => {
    this.scrollPosition = e.target.scrollHeight - e.target.scrollTop
    this.currentHeighScrollContainer = e.target.scrollHeight
    this.currentTopScrollContainer = e.target.scrollTop
    if (e.target.scrollTop < 200) {
      if (this.state.deviceConfig.mobDevice) {
        if(!this.paramsWidget.use_nod_red){
          this.fetchHistory()
        } else {

         !this.loadingHistoryMob && !this.state.cliclCloseWidget && !!this.state.buttonLoadingHistory.clickedButton &&  this.getHistoryDialogsForNodeRedBot() 
        }
      } else if(this.worker && this.worker.port){
        if(!this.paramsWidget.use_nod_red){
          this.worker.port.postMessage({ method: 'fetchHistory', idWidget: this.paramsWidget.idWidget })

        } else {
          this.state.buttonLoadingHistory.clickedButton && this.worker.port.postMessage({ method: 'fetchHistory', idWidget: this.paramsWidget.idWidget })
        }
      }
    }
    if(this.state.marker.offsetTop &&
      this.refScroll.current.scrollTop >= this.state.marker.offsetTop
    ){
      this.setState({
        marker: {
          ...this.state.marker,
          notReadMessage: false,
          offsetTop: 0,
          element: undefined
        }
      })
    }
  }

  clickSendMeesageToWorkerGetHistory = () => {
    this.setState({
      buttonLoadingHistory: {
        ...this.state.buttonLoadingHistory,
        clickedButton: true
      }
    }, () => {
      if(this.paramsWidget.use_nod_red && window.SharedWorker && !this.checkDevise()) {
        this.worker.port.postMessage({ method: 'fetchHistory', idWidget: this.paramsWidget.idWidget })
      } else {
        this.getHistoryDialogsForNodeRedBot()
      }
    })
  }

  fetchHistory = (pathname) => {
    if(!this.paramsWidget.use_nod_red) { // TODO: delete after fix back 
      this.setStatusLoadingHistory(true)
      if (!this.loadingHistoryMob && !this.loadingLastHistory) {
        this.loadingHistoryMob = true
        const {idWidget} = this.paramsWidget
        api.fetchData(`api/widget/history?widgetID=${idWidget || rootIdWidget}&time=${this.state.time}`).then(({ data }) => {
          const reverseData = data.reverse()
          const parseData = this.parseBlock(reverseData)
          let lastParentId = this.state.lastParentId
          if (data.length) {
            if (this.state.lastParentId === 0) {
              lastParentId = [...data].reverse().find(item => item.blockType === 1 || item.blockType === 2)
              lastParentId = (lastParentId && lastParentId.id) || 0
            }
            if (pathname) {
              // const currentPathname = this.currentPathname
              // if(data[data.length - 1].blockType === 1 && currentPathname !== pathname){
              this.currentPathname = pathname
              // }
            }
            this.loadingHistory = (this.loadingHistory === null)
            this.setState({
              arrMessage: [
                ...parseData,
                ...this.state.arrMessage
              ],
              lastParentId,
              time: reverseData[0].dateTime
            }, () => this.updateScrollPosition(true))
          } else {
            // this.frequentlyAskedQuestion(pathname || '')
          }
          this.loadingHistoryMob = false
          this.loadingLastHistory = data.length < 10
          this.finishLoadingHistory = data.length < 10
          this.setStatusLoadingHistory(false)
        })
      }
    }
  }

  doubleValue = (value) => {
    if(value <= 9) return `0${value}`
  
    return value
  }
  
  getDateTime = (dateMessage) => {
    if(!dateMessage) return ''
  
    const dateTime = new Date(dateMessage)
  
    let date = this.doubleValue(dateTime.getDate())
    let monts = this.doubleValue(dateTime.getMonth() + 1)
  
    const years = dateTime.getFullYear()
    const hours = this.doubleValue(dateTime.getHours())
    const minutes = this.doubleValue(dateTime.getMinutes())
  
    return `${hours}:${minutes} ${date}.${monts}.${years}`
  }

  getHistoryDialogsForNodeRedBot = () => {
    if( this.loadingLastHistory || this.finishLoadingHistory || this.state.cliclCloseWidget) return 
    this.loadingHistoryMob = true

    const {id} = this.paramsWidget
    const limit = 100
    const page = this.pageHistory
    this.setStatusLoadingHistory(true)
    this.setState({
      ...this.state,
      buttonLoadingHistory: {
        ...this.state.buttonLoadingHistory,
        show: false,
        isLoading: true,
        clickedButton: true
      },
      notification: {
        show: false,
        type: '',
        text: ''
      }
    })
                
    fetch('api/bots/askme/widget/history', {
      method: 'POST',
      headers: {
        "x-auth-token": "JHJosDiOlHGHGdytEOjkh8hgKf88",
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit,
        page,
        dialogId: this.dialogId
      })
    }).then(async response => {
      const res = await response.json()
      if (response.status === 200) {
        const arrMwssages = []
        console.log(res)

        if(res.dialogues){
          res.dialogues
            .filter(historyDialog =>
              historyDialog
              && !historyDialog.empty
              && id === historyDialog.channel.token
            )
            .reverse()
            .forEach(historyDialog => {
              if(!historyDialog.messages) return 
    
              historyDialog.messages
                .reverse()
                .forEach(message => {
                  if (message.show_client) {

                    const timeMessage = message.time ? this.getDateTime( message.time) : ''

                    if (message.files && message.files.length) {
                      const file = message.files[0]
                      arrMwssages.push({
                        id: message.message_id || message.id,
                        blockType: 10,
                        fileName: file.file_name,
                        fileURL: file.file_url,
                        fileSize: file.file_size,
                        fileType: file.file_type,
                        typeMessage: message.role === "client" ? 'user' : 'system' ,
                        status: 'success',
                        timeMessage
                      })
                    } else {
                      arrMwssages.push(
                        {
                          id: message.id,
                          blockType: message.role === "client" ? 5 : 6,
                          text: message.text,
                          timeMessage
                        }
                      )
    
                    }
    
                  }
                })
            })
  
            this.pageHistory = page + 1
            const onlyOneMessage = this.state.arrMessage.length === 1
            this.setState(prevState => ({
              arrMessage: [
                ...arrMwssages,
                ...this.state.arrMessage
              ],
              buttonLoadingHistory: {
                ...prevState.buttonLoadingHistory,
                isLoading: false,
              }
            }), () => {
              if(onlyOneMessage){
                this.updateScrollPosition(false, true)
                
              } else {
                this.updateScrollPosition(true)
              }
            })
        } else {
          this.setState(prevState => ({
            buttonLoadingHistory: {
              ...prevState.buttonLoadingHistory,
              isLoading: false,
            }
          }))
        }
      }
      this.setStatusLoadingHistory(false)
      this.loadingHistoryMob = false
      this.loadingLastHistory = (limit * page) > res.count
      this.finishLoadingHistory = (limit * page) > res.count
    })
    .catch(() => {
      this.setState(prevState => ({
        ...prevState,
        buttonLoadingHistory: {
          show: true,
          isLoading: false,
          clickedButton: false
        },
        notification: {
          show: true,
          type: 'warning',
          text: 'Не вдалося отримати історію. Спробуйте будь ласка пізніше.'
        }
      }))
      this.loadingHistoryMob = false
      this.setStatusLoadingHistory(false)
    })
  }

  setStatusLoadingHistory = status => {
    this.loadingHistory = status
  }
  parseBlock = arrBlock => {
    const {use_nod_red} = this.paramsWidget
    return arrBlock.map(block => {
      switch (block.blockType) {
        case 1:
        case 2: {
          return {
            id: block.id,
            blockType: 1,
            variable: block.faqs,
            title: block.blockType === 1 ? 'Популярні питання' : ''
          }
        }
        case 3: {
          return {
            blockType: 3,
            id: block.faqs[0].id,
            title: block.faqs[0].name,
            text: block.faqs[0].text
          }
        }
        case 4: {
          return {
            id: block.id,
            blockType: 4,
            rating: block.contents[0].rateValue,
            idFaq: block.id
          }
        }
        case 5: {
          return {
            id: block.contents[0].id,
            blockType: 5,
            typeMessage: 'client_message',
            text: block.contents[0].textContent
          }
        }
        case 6: {
          if(!use_nod_red){
            return {
              id: block.id,
              blockType: 6,
              text: 'Будь ласка уточніть Ваше питання'
            }
          }
          break
        }
        case 7: {
          return {
            id: block.id,
            blockType: 7,
          }
        }
        case 8: {
          return {
            id: block.id,
            blockType: 8,
            text: 'Дякуємо за оцінку!'
          }
        }
        default: break;
      }
      return null // !DELETE
    })
    .filter(message => message)
  }
  updateHeightFrame = (id, heightFrame) => {
    const {arrMessage} = this.state
    const newArrMessage = arrMessage.map(message => {
      if(`${message.id}` !== `${id}` ) return message
      
      return { ...message, heightFrame}
    })
    this.setState({ arrMessage: newArrMessage})
  }

  checkLastMessageEstimationBot = () => {
    if(!this.paramsWidget.use_nod_red) return false
    try {
      if(this.state.arrMessage && this.state.arrMessage.length && this.state.arrMessage[this.state.arrMessage.length - 1]) {
        const lastMessage = this.state.arrMessage[this.state.arrMessage.length - 1]
        if(lastMessage.blockType === 9){
          return lastMessage.text.includes('name=estimation')
        }
      }
  
      return false
    } catch (error) {
      return false
    }
  }

  showImage = (urlImage) => {
    if(this.checkDevise()){
      this.setState({ imageURL: urlImage})
    } else {
      window.parent.postMessage(JSON.stringify({ type: 'show_image', idWidget: this.paramsWidget.idWidget, urlImage }), '*')
    }
    
  }

  sendFile = e => {
    const formData = new FormData()
    const files = e.target.files

    const arrMessages = []

    formData.append('dialogID', this.dialogId)
    for(let i = 0; i < files.length; i++){
      formData.append('files', files[i])
      arrMessages.push({
        id: new Date().getTime(),
        blockType: 10,
        fileName: files[i].name,
        fileURL: '',
        fileSize: files[i].size,
        fileType: files[i].type,
        typeMessage: 'user',
        status: 'loading'
      })
    }

    if(window.SharedWorker && !this.checkDevise()){
      this.worker.port.postMessage({
        method: 'WIDGET_ADD_MESSAGE',
        idWidget: this.paramsWidget.idWidget,
        arrMessages
      })
    } else {
      this.setState({
        arrMessage: [
          ...this.state.arrMessage,
          ...arrMessages
        ]
      })
    }

    api.sendFiles(formData)
    .then(res => {
      if(res.status === 200){
        this.successDownloadFile(arrMessages, res)
      } else { 
        this.failureDownloadFile(arrMessages)
      }
    })
    .catch(error => {
      console.error(error);
      this.failureDownloadFile(arrMessages)
    })
  }

  successDownloadFile = (arrMessages, res) => {
    const filesWithUrl = arrMessages.map(messageInStore => {
      const findFile = res.data.find(newFile => newFile.fileName.includes(messageInStore.fileName))
      return {
        ...messageInStore,
        fileURL: findFile.fileURL
      }
    })

    console.log('debug files', this.newListWithUpdatedStatusFile('success', filesWithUrl))
    if(window.SharedWorker && !this.checkDevise()){
      this.worker.port.postMessage({
        method: 'WIDGET_UPDATE_STATUS_LOADING_FILE',
        idWidget: this.paramsWidget.idWidget,
        arrMessages: this.newListWithUpdatedStatusFile('success', filesWithUrl)
      })
    } else {
      let isScrolling = true
      const z = this

      const updatedArrMessages = this.newListWithUpdatedStatusFile('success', filesWithUrl)
      const newArr = this.state.arrMessage.map(message => {
        
        const messageForUpdate = updatedArrMessages.find(updatedMessage => updatedMessage.id === message.id)
  
        if(!messageForUpdate){ return message}
  
        // isScrolling = message.fileType && message.fileType.includes('image')
        return { ...message, ...messageForUpdate }
      })
      this.setState({ arrMessage: newArr },
        () => {
          if(isScrolling){
            setTimeout(() => {
              z.updateScrollPosition()
            }, 1000)
          }
        })
    }
  }

  failureDownloadFile = (arrMessages) => {
    const updatedArrMessages = this.newListWithUpdatedStatusFile('failure', arrMessages)

    if(window.SharedWorker && !this.checkDevise()){
      this.worker.port.postMessage({
        method: 'WIDGET_UPDATE_STATUS_LOADING_FILE',
        idWidget: this.paramsWidget.idWidget,
        arrMessages: updatedArrMessages
      })
    } else {
      const newArr = this.state.arrMessage.map(message => {
        const messageForUpdate = updatedArrMessages.find(updatedMessage => updatedMessage.id === message.id)
  
        if(!messageForUpdate){ return message}
  
        return { ...message, ...messageForUpdate }
      })

      this.setState({ arrMessage: newArr })
    }
  }

  newListWithUpdatedStatusFile = (status, arrFiles) => {
    return this.state.arrMessage.map(message => {
      const fileInStore = arrFiles.find(addedFile => addedFile.id === message.id ) 
      if(!fileInStore){
        return message
      }

      return {
        ...message,
        status,
        fileURL: fileInStore.fileURL
      }
    })
  }
  updateUrlBot = (url) => {
    domainFullNameBot = url
    const isNew = domainFullNameBot === NEW_BOT
    this.setState({ newBot: isNew})
    localStorage.setItem('bot', isNew ? 'new' : 'old')
    if(!this.checkDevise()) {
      window.parent.postMessage(JSON.stringify({type: 'setLinkBot', url: domainFullNameBot}), '*')
    }
  }

  updateBot = () => {
    if(this.checkDevise() || !window.SharedWorker) {
      this.updateUrlBot(domainFullNameBot === CURRENT_BOT ? NEW_BOT : CURRENT_BOT)
    } else {
      this.worker.port.postMessage({
        method: 'updateUrlBot',
        idWidget: this.paramsWidget.idWidget,
        url: domainFullNameBot === CURRENT_BOT ? NEW_BOT : CURRENT_BOT,
      })
    }
  }


  render() {
    // console.log('debug file root state', this);
    const { arrMessage, countMessage, value, showWidget, pathname, originURL, marker, buttonLoadingHistory, notification } = this.state
    if(localStorage.getItem('debug')){
      console.log('debug file root state', this);
    }
    const navigationButton = this.showNavigationButton()
    if (!showWidget) return null
    const isMob = this.checkDevise() ? 'mob' : ''
    const lastMessageIsBotEstimation = this.checkLastMessageEstimationBot()
    const blockedInputField = lastMessageIsBotEstimation

    let newArrMessage = [...arrMessage]

    if(lastMessageIsBotEstimation) {
      newArrMessage = [arrMessage[arrMessage.length - 1]]
    }

    console.log('domainFullNameBot', domainFullNameBot)

    return (
      <div className="widget">
        {this.state.imageURL.length !== 0 && <ModalShowImage image={this.state.imageURL} close={() => this.setState({ imageURL: ''})}/>  }
        <header>
          <img className='logo' src={logo} alt='logo' />
          <div className='title-container'>
            {/* <a href='https://google.com.ua' onClick={() => alert('click link')}> */}
              <span className='name-company'>{this.paramsWidget.name || ''}</span>
            {/* </a> */}
            <span className='sub-title'>Онлайн допомога</span>
          </div>
          <div className='btns'>
            {this.paramsWidget.use_nod_red ? <button className={`${isMob} button_collapse`} onClick={() => this.collapseWidget(true)}/> : '' }
            <button className='button_close-mob' onClick={this.hideWidget} />
          </div>

        </header>
        <Content
          arrMessage={newArrMessage}
          showNavigation={true}
          countMessage={countMessage}
          navigationButton={navigationButton}
          pathname={pathname}
          originURL={originURL}
          handleNavigation={this.handleNavigation}
          handleChangeFAQ={this.handleChangeFAQ}
          handleResultAsked={this.handleResultAsked}
          handleClickMessanger={this.handleClickMessanger}
          scrollContainer={this.scrollContainer}
          myRef={this.myRef}
          refScroll={this.refScroll}
          useNodeRed={this.paramsWidget.use_nod_red}
          widgetId={this.paramsWidget.idWidget || rootIdWidget}
          babyToken={this.babyToken}
          dialogId={this.dialogId}
          showImage={this.showImage}
          paramsApp={this.paramsApp } 
          buttonLoadingHistory={buttonLoadingHistory}
          clickSendMeesageToWorkerGetHistory={this.clickSendMeesageToWorkerGetHistory}
          notification={notification}
        />
        {(!blockedInputField /* || this.state.visibleInputField */) &&<form onSubmit={this.handleSubmit} className='footer'>
        {marker.notReadMessage && <span className='marker-not_read' onClick={this.handleChangeScrollMarker}/>}
          <input
            ref={this.refInput}
            className='input-search'
            placeholder='Поставте ваше питання…'
            value={value}
            onChange={this.handleChange}
            autoFocus={true}
          />
          <button className={`send-search ${value.length && 'active'}`} type='submit'><IconSend /></button>
          <ButtonFile handlerClick={this.sendFile}/>
        </form>}
      </div>
    );
  }
}

export default Widget;
